export const getColor = (variants, variantIndex) => {
  var _variants$variantInde;
  return variants ? ((_variants$variantInde = variants[variantIndex]) === null || _variants$variantInde === void 0 ? void 0 : _variants$variantInde.name) || '' : '';
};